function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnSizeincrease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M30.47 30.63H9.53V9.37h20.94zm.74-22.78H8.79a.75.75 0 0 0-.79.76v22.78a.75.75 0 0 0 .75.76h22.46a.75.75 0 0 0 .75-.76V8.61a.75.75 0 0 0-.75-.76m-8.44 10.41 4-4v3.48h1.49v-5.33a.75.75 0 0 0-.74-.76h-5.28v1.52h3.43l-4 4zM12.52 28.35h5.24v-1.52h-3.43l4-4-1.05-1.07-4 4v-3.48h-1.5v5.31a.75.75 0 0 0 .74.76",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSizeincrease);
export default __webpack_public_path__ + "static/media/icn-sizeincrease.d1d1bdad4ce10216354adc0e4926d77e.svg";
export { ForwardRef as ReactComponent };